import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="17" height="28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M2 10.999h14v16H2zm-.375-4.268l13.203-4.486" /></svg>);